var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApproval(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0466 5.95378C15.7664 5.34233 14.333 5 12.8197 5C7.39641 5 3 9.39641 3 14.8197C3 20.2429 7.39641 24.6393 12.8197 24.6393C18.2429 24.6393 22.6393 20.2429 22.6393 14.8197",
    stroke: "#8B93A7",
    strokeWidth: 2.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55579 13.4973L12.918 17.1791L24.1192 5.35351",
    stroke: "#8B93A7",
    strokeWidth: 2.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproval);
export default __webpack_public_path__ + "static/media/approval.054dc72ea9aee51fc5c31ffdd3fc6133.svg";
export { ForwardRef as ReactComponent };